import { useState } from "../imports";

export const usePopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [shortenedCode, setShortenedCode] = useState<string | null>(null);

  const openPopup = (code: string) => {
    setShortenedCode(code);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setShortenedCode(null);
  };

  return {
    showPopup,
    shortenedCode,
    openPopup,
    closePopup,
  };
};
